/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/buttons/checkbox.scss';

const propTypes = {
    name: PropTypes.string,
    label: AppPropTypes.text,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    disabled: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
    onChange: PropTypes.func,
};

const defaultProps = {
    name: null,
    value: null,
    label: null,
    disabled: false,
    className: null,
    onClick: null,
    onChange: null,
};

function CheckboxField({ name, label, value, disabled, onClick, onChange, className }) {
    const onInputChange = useCallback(
        (e) => {
            if (onChange !== null) {
                onChange(e.currentTarget.checked);
            }
        },
        [onChange],
    );
    return (
        <label
            htmlFor={name}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <span className={styles.check}>
                <input
                    type="checkbox"
                    name={name}
                    id={name}
                    disabled={disabled}
                    checked={value || false}
                    onChange={onClick || onInputChange}
                    className={styles.input}
                />
            </span>
            <span className={styles.label}>{label}</span>
        </label>
    );
}

CheckboxField.propTypes = propTypes;
CheckboxField.defaultProps = defaultProps;

export default CheckboxField;
